import React from 'react';
import './Navbar.css';
import { useCart } from '../context/CartContext';

function Navbar({ setCurrentSection, currentSection }) {
  const { getTotalItems } = useCart();
  const totalItems = getTotalItems();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src="/afro-logo.png" alt="AfroStyle Logo" className="logo-image" />
        </div>
        <ul className="navbar-menu">
          <li>
            <button
              className={`nav-link ${currentSection === 'home' ? 'active' : ''}`}
              onClick={() => setCurrentSection('home')}
            >
              Home
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${currentSection === 'wrappers' ? 'active' : ''}`}
              onClick={() => setCurrentSection('wrappers')}
            >
              Wrappers
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${currentSection === 'shoes' ? 'active' : ''}`}
              onClick={() => setCurrentSection('shoes')}
            >
              Shoes
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${currentSection === 'bags' ? 'active' : ''}`}
              onClick={() => setCurrentSection('bags')}
            >
              Bags
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${currentSection === 'art' ? 'active' : ''}`}
              onClick={() => setCurrentSection('art')}
            >
              🎨 Art
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${currentSection === 'livestream' ? 'active' : ''}`}
              onClick={() => setCurrentSection('livestream')}
            >
              🔴 Live
            </button>
          </li>
          <li>
            <button
              className={`nav-link ${currentSection === 'blog' ? 'active' : ''}`}
              onClick={() => setCurrentSection('blog')}
            >
              📚 Blog
            </button>
          </li>
          <li>
            <button
              className={`nav-link cart-btn ${currentSection === 'cart' ? 'active' : ''}`}
              onClick={() => setCurrentSection('cart')}
            >
              🛒 Cart
              {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
